import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import { TreatmentPlanSelectorResult } from '@ispm-client/modules/bpmn-modeler/models/treatment-plan-selector-result';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { nodesDetailsExtensionType } from '@ispm-shared/modules/bpmn/diagram-element-terms';
import { Shape } from 'diagram-js/lib/model';
import { BpmnExtensionHelper } from '@ispm/shared/bpmn-io/bpmn-extension-helper';

export class TreatmentNodeUpdateHandler implements CommandHandler {

    constructor(private modeling, private moddle, private bpmnExtensionHelper: BpmnExtensionHelper) {

    }

    postExecute(context): any {
        const node = context.node,
              data: TreatmentPlanSelectorResult = context.data;
        this.setNodeName(data, node);
        this.addNotes(node, data.additionalNote);
    }


    private setNodeName(data: TreatmentPlanSelectorResult, node) {
        let treatmentPlanNodeName;
        const primaryTreatmentPlanArr = data.treatmentPlans.filter(treatmentPlan => treatmentPlan.primary);
        if (primaryTreatmentPlanArr && primaryTreatmentPlanArr.length > 0) {
            const primaryPlan = primaryTreatmentPlanArr[0];
            const nameArr = [primaryPlan.treatmentPlan.regimen];
            if (data.treatmentPlans.length > 1) {
                nameArr.push(`${data.treatmentPlans.length - 1} Other on-pathway treatment`);
            }
            treatmentPlanNodeName = nameArr.join('\n');
        }
        else {
            treatmentPlanNodeName = `${data.treatmentPlans.length} On-pathway treatment plans`;
        }
        this.modeling.updateProperties(node, { name: treatmentPlanNodeName});
    }

    private addNotes(node: Shape, additionalNote: string) {
        const nodeDetails = ModelingUtil.getNodeDetails(node) || this.moddle.create(nodesDetailsExtensionType);
        nodeDetails.additionalNote = additionalNote;
        this.bpmnExtensionHelper.addOrReplaceExtension(node, nodeDetails);
    }
}
